import {
  ProviderFeatureDiscoveryKey,
  ProviderFeatureDiscoveryStatusResponse,
} from "../../../recoil/types";
import { fetchOrLogout } from "../../../utils/helpers";
import { getBaseUrl } from "../../../utils/requestUtils";

export const GetProviderFeatureDiscoveryStatus = async (
  token: string,
  setLoggedOut: (inactivity: boolean) => void,
): Promise<ProviderFeatureDiscoveryStatusResponse> => {
  const baseUrl = await getBaseUrl();
  const response = await fetchOrLogout(
    `${baseUrl}/api/v1/provider_portal/feature_discovery`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
    setLoggedOut,
  );

  return response.json();
};

export const MarkProviderFeatureDiscoverySeen = async (
  token: string,
  featureKey: ProviderFeatureDiscoveryKey,
  setLoggedOut: (inactivity: boolean) => void,
): Promise<Response> => {
  const baseUrl = await getBaseUrl();
  return fetchOrLogout(
    `${baseUrl}/api/v1/provider_portal/feature_discovery`,
    {
      method: "POST",
      body: JSON.stringify({
        feature_discovery: featureKey,
      }),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
    setLoggedOut,
  );
};
